import { render, staticRenderFns } from "./AvvisiLogin.vue?vue&type=template&id=6b07f0ea&"
import script from "./AvvisiLogin.vue?vue&type=script&lang=js&"
export * from "./AvvisiLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports